import { EntityBase } from "./EntityBase";

export class State extends EntityBase {
    name: string = null!;
    stateCode: string = null!;
    rescissionPeriod: number | null = null;
}
